import React, { useState } from 'react';
import { BrandIcon } from '../primitives/icons';
import { CharacterAvatar } from '../primitives/CharacterAvatar';
import { BgColorControl } from './BgColorControl';

export const TopBar = ({ theme, density, user, onOpenThemes, bgColor, setBgColor, themeBgColor }) => {
  const t = theme.typography || {};
  const e = theme.effects || {};
  const c = theme.colors;
  const [isOnline, setIsOnline] = useState(false);
  const [statusHover, setStatusHover] = useState(false);

  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      marginBottom: density.spacing.sectionGap, flexWrap: 'wrap', gap: 12,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
        <BrandIcon size={36} />
        <div>
          <div style={{
            fontFamily: t.headingFamily || 'Georgia, serif',
            fontSize: '1.45rem',
            color: c.accentLight,
            fontWeight: 600,
            lineHeight: 1.1,
            textShadow: e.headingTextShadow,
          }}>Survival Tracker</div>
          <div style={{
            fontSize: '0.65rem',
            letterSpacing: '0.32em',
            color: c.textMuted,
            textTransform: 'uppercase',
            marginTop: 3,
            fontFamily: t.fontFamily,
          }}>Campaign Companion</div>
        </div>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        {/* Background color picker. The swatch displays the current bgColor;
            clicking it opens the OS native color picker. The small ▾ button
            cycles through quick presets: black → theme bg → black. */}
        <BgColorControl
          theme={theme} density={density}
          bgColor={bgColor} setBgColor={setBgColor}
          themeBgColor={themeBgColor}
        />

        <button
          onClick={onOpenThemes}
          style={{
            padding: '7px 12px',
            background: c.bgCardSolid,
            border: `1px solid ${c.borderPrimary}`,
            borderRadius: 999,
            color: c.textSecondary,
            cursor: 'pointer',
            fontSize: density.typography.labelSize,
            fontFamily: t.fontFamily,
            display: 'inline-flex',
            alignItems: 'center',
            gap: 7,
          }}
        >🎨 Theme</button>

        {/* Online toggle — subtle status indicator. Offline default
            (empty outline circle, muted); clicking flips to online
            (success color, dot in the center). No glow, no label —
            just a small affordance. Custom tooltip on hover replaces
            the native title attribute. */}
        <div
          style={{ position: 'relative', display: 'inline-flex' }}
          onMouseEnter={() => setStatusHover(true)}
          onMouseLeave={() => setStatusHover(false)}
        >
          <button
            onClick={() => setIsOnline(prev => !prev)}
            style={{
              width: 22, height: 22,
              borderRadius: '50%',
              background: 'transparent',
              border: `1.5px solid ${isOnline ? c.success : c.textMuted}`,
              padding: 0,
              cursor: 'pointer',
              display: 'inline-flex',
              alignItems: 'center', justifyContent: 'center',
              transition: 'border-color 150ms ease',
            }}
          >
            {isOnline && (
              <span style={{
                width: 8, height: 8,
                borderRadius: '50%',
                background: c.success,
              }} />
            )}
          </button>
          {/* Custom tooltip — replaces native title for theme-consistent
              styling. Positioned below the toggle, centered, with a small
              arrow pointing up. Fades/slides in on hover. */}
          <div
            role="tooltip"
            style={{
              position: 'absolute',
              top: 'calc(100% + 10px)',
              left: '50%',
              transform: `translateX(-50%) translateY(${statusHover ? '0' : '-4px'})`,
              opacity: statusHover ? 1 : 0,
              pointerEvents: 'none',
              transition: 'opacity 140ms ease, transform 140ms ease',
              background: c.bgCardSolid,
              border: `1px solid ${c.borderPrimary}`,
              borderRadius: 6,
              padding: '6px 10px',
              fontSize: '0.75rem',
              fontFamily: t.fontFamily,
              color: c.textPrimary,
              whiteSpace: 'nowrap',
              boxShadow: '0 4px 12px rgba(0,0,0,0.4)',
              zIndex: 10,
            }}
          >
            {/* Arrow — small square rotated 45deg, sits above the bubble */}
            <span style={{
              position: 'absolute',
              top: -4,
              left: '50%',
              transform: 'translateX(-50%) rotate(45deg)',
              width: 7, height: 7,
              background: c.bgCardSolid,
              borderTop: `1px solid ${c.borderPrimary}`,
              borderLeft: `1px solid ${c.borderPrimary}`,
            }} />
            {isOnline ? 'Click to go offline' : 'Click to go online'}
          </div>
        </div>

        <button
          title={`${user.name} (${user.handle})`}
          style={{
            width: 36, height: 36,
            borderRadius: '50%',
            background: c.bgCardSolid,
            border: `1px solid ${c.borderPrimary}`,
            padding: 0,
            cursor: 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            overflow: 'hidden',
            color: c.accentLight,
            transition: e.transition,
          }}
        >
          <CharacterAvatar char={user} size={36} color={c.accentLight} fontFamily={t.headingFamily} />
        </button>
      </div>
    </div>
  );
};
